module.exports = __webpack_public_path__ + "img/popularity-checked-ms.cc68614b.png";